/**
 * Primary controller for editing a user's profile.
 * @author Brendan Magee
 */

function ProfilePreferencesController(
  $scope,
  $http,
  $translate,
  $log,
  $q,
  $state,
  Integration,
  localStorageService,
  peopleService,
  filtersService,
  navigationService,
  savedSearchService,
  toastWrapperService,
  analyticsService
) {
  const successSaved = `${$translate.instant('DEFAULT_SAVED_SEARCH')}: `;
  const successCleared = $translate.instant('DEFAULT_SAVED_SEARCH_CLEARED');

  const storyUrlPath = 'planning.list';

  // Configs for default saved search load spinner
  $scope.savingDefault = {
    enable: false,
    success: null
  };

  $scope.clearingDefault = {
    enable: false,
    success: null
  };

  navigationService.navigateProfile('profile.preferences');

  $q.all([
    savedSearchService.getAll(),
    Integration.getAllByType('slack'),
    peopleService.getUser()
  ]).then(([savedSearchData, integrations, user]) => {
    $scope.savedSearchOptions = savedSearchData.results;

    // Pass integrations list to `slackUsername` component
    $scope.integrations = integrations || [];
    $scope.user = user;
    const { preferences } = user;

    if (preferences && preferences.defaultSavedSearch) {
      $scope.defaultId = preferences.defaultSavedSearch.id;
    }

    $scope.defaultSavedSearch = $scope.savedSearchOptions.find(option =>
      (option.id === $scope.defaultId));

    $scope.searchUpToDate = $scope.defaultSavedSearch && $scope.defaultSavedSearch.id ===
      $scope.defaultId;
  }).catch((error) => {
    $log.error(error);
    throw new Error('Error getting data on profile preferences page');
  });

  $scope.checkUpToDate = () => {
    $scope.searchUpToDate = $scope.defaultSavedSearch && $scope.defaultSavedSearch.id ===
      $scope.defaultId;
  };

  // Set the default saved search when the user submits the form
  $scope.updateDefault = (value = '') => {
    if (!value) {
      $scope.clearingDefault.enable = true;
    } else {
      $scope.savingDefault.enable = true;
    }

    $http.put('api/user', { defaultSavedSearchId: value })
      .then((response) => {
        const newDefault = response.data.defaultSavedSearchId;
        let analyticsEvent;

        if (!newDefault.length) {
          $scope.clearingDefault.enable = false;
          $scope.clearingDefault.success = true;
          analyticsEvent = 'Cleared default saved search';
        } else {
          $scope.savingDefault.enable = false;
          $scope.savingDefault.success = true;
          analyticsEvent = 'Set default saved search';
        }

        $scope.defaultSavedSearch = $scope.savedSearchOptions.find(option =>
          (option.id === newDefault));

        $scope.searchUpToDate = true;

        const successMessage = newDefault.length ? successSaved + $scope.defaultSavedSearch.name
          : successCleared;

        toastWrapperService.createToast(successMessage, 'success');
        analyticsService.trackEvent('User preferences management', analyticsEvent);
      }, (error) => {
        $log.error(error);

        let failedUpdate;

        if (error.config && error.config.data) {
          failedUpdate = error.config.data;
        }

        if (failedUpdate && !failedUpdate.defaultSavedSearchId.length) {
          $scope.clearingDefault.enable = false;
          $scope.clearingDefault.success = false;
        } else if (failedUpdate && failedUpdate.defaultSavedSearchId.length) {
          $scope.savingDefault.enable = false;
          $scope.savingDefault.success = false;
        }

        toastWrapperService.createToast($translate.instant('ERROR_UPDATING_DEFAULT_SAVED_SEARCH'), 'danger');
      });
  };

  // Take the user to the stories page with the saved search panel open
  $scope.goToSavedSearches = () => {
    localStorageService.set('websked.panel-stories', 'saved');
    $state.go(storyUrlPath, filtersService.defaultFilters);
  };
}

const arr = [
  '$scope',
  '$http',
  '$translate',
  '$log',
  '$q',
  '$state',
  'Integration',
  'localStorageService',
  'peopleService',
  'filtersService',
  'navigationService',
  'savedSearchService',
  'toastWrapperService',
  'analyticsService',
  'featureFlag',
  ProfilePreferencesController
];

module.exports = (ngModule) => {
  ngModule.controller('ProfilePreferencesController', arr);
};
